module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-styled-components/gatsby-browser.js'),
      options: {"plugins":[],"displayName":true,"fileName":true,"minify":true,"namespace":"","transpileTemplateLiterals":true,"topLevelImportPaths":[],"pure":false,"disableVendorPrefixes":false},
    },{
      plugin: require('../node_modules/gatsby-plugin-prismic-previews/gatsby-browser.js'),
      options: {"plugins":[],"repositoryName":"commercial-helios","accessToken":"MC5YdGU0UGhBQUFDTUFMOFFj.FO-_vTlQ77-977-977-9UFkl77-977-9IUpa77-977-977-977-9QQnvv73vv71677-977-977-977-977-977-977-977-9","toolbar":"new","promptForAccessToken":true,"apiEndpoint":"https://commercial-helios.cdn.prismic.io/api/v2","lang":"*","imageImgixParams":{"auto":"compress,format","fit":"max","q":50},"imagePlaceholderImgixParams":{"w":100,"blur":15}},
    },{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-segment-js/gatsby-browser.js'),
      options: {"plugins":[],"host":"https://cdn.insights.pleo.io","prodKey":"1SribV2gq3K37QKlY2hMY75wQzlbvTF4","devKey":"1SribV2gq3K37QKlY2hMY75wQzlbvTF4","trackPage":false,"manualLoad":true},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    }]
